import { __assign } from "tslib";
import React from "react";
import { getEnv } from "@adsk/acs-sc-web-platform-api";
import { Reset } from "@adsk/alloy-react-theme";
import { CreateTemplateModal } from "./CreateTemplateModal";
import { useCreateTemplateModalProps } from "./useCreateTemplateModalProps";
import { LaunchDarklyIdByEnv } from "../shared/constants";
import { LaunchDarklyProvider } from "../shared/components/LaunchDarklyContext";
export var CreateTemplateModalContainer = function (props) {
    var createTemplateModalProps = useCreateTemplateModalProps({
        open: props.open,
        onClose: props.onClose,
        onSuccess: props.onSuccess,
        onFailure: props.onFailure,
    });
    var env = getEnv();
    return (React.createElement(React.Fragment, null,
        React.createElement(Reset, null),
        React.createElement(LaunchDarklyProvider, { apiKey: LaunchDarklyIdByEnv[env], projectEntitlementsUnavailable: true },
            React.createElement(CreateTemplateModal, __assign({}, createTemplateModalProps)))));
};
